import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRightBig = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 39.999, height: 30, viewBox: "0 0 39.999 30", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { id: "Pfad_763037857", "data-name": "Pfad 763037857", d: "M998.923,560.193a1,1,0,0,0-.217-1.09l-14-14a1,1,0,1,0-1.414,1.415l12.293,12.293H960a1,1,0,0,0,0,2h35.586L983.293,573.1a1,1,0,1,0,1.414,1.415l14-14A1,1,0,0,0,998.923,560.193Z", transform: "translate(-959 -544.812)", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgArrowRightBig);
export { ForwardRef as ReactComponent };
